import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'confluenceInsertButtonLabel'
	| 'jiraInsertButtonLabel'
	| 'genericInsertButtonLabel'
	| 'replaceButtonLabel'
	| 'tooltipMessage';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		confluenceInsertButtonLabel: {
			id: 'rovo-chat.store-assistant.insert-replace.confluence-insert-button-label',
			defaultMessage: 'Insert into page',
			description: 'Label for the confluence insert button',
		},
		jiraInsertButtonLabel: {
			id: 'rovo-chat.store-assistant.insert-replace.jira-insert-button-label',
			defaultMessage: 'Insert into work item',
			description: 'Label for the jira insert button',
		},
		genericInsertButtonLabel: {
			id: 'rovo-chat.store-assistant.insert-replace.generic-insert-button-label',
			defaultMessage: 'Insert',
			description: 'Label for the generic insert button',
		},
		replaceButtonLabel: {
			id: 'rovo-chat.store-assistant.insert-replace.replace-button-label',
			defaultMessage: 'Replace selection',
			description: 'Label for the replace button that replaces selected text with AI content',
		},
		tooltipMessage: {
			id: 'rovo-chat.store-assistant.insert-replace.tooltip-message',
			defaultMessage:
				'This feature isn’t supported in your current context. Try selecting, writing, or editing text on the page.',
			description: 'Tooltip message for the insert replace button',
		},
	});

export default message;
